import React from 'react';
import { Badge } from 'react-bootstrap';

const AuditLogDetails = ({ log }) => {
  if (!log.details) return '-';
  
  const { action, details } = log;

  if (action === 'IMPORT') {
    return `Imported ${details.count} transactions to ${details.bankAccount}`;
  }

  if (action === 'BULK_UPDATE') {
    return (
      <div className="small">
        <div className="mb-2">
            Updated <strong>{details.count}</strong> transactions to <Badge variant="primary">{details.category}</Badge>
        </div>
        {details.transactions && (
            <ul className="list-unstyled mb-0" style={{ fontSize: '0.7rem', opacity: 0.8 }}>
                {details.transactions.slice(0, 5).map((tx, i) => (
                    <li key={i} className="text-truncate">
                        <i className="fas fa-check-circle text-success mr-1"></i> {tx.description}
                    </li>
                ))}
                {details.transactions.length > 5 && <li className="font-italic">...and {details.transactions.length - 5} more</li>}
            </ul>
        )}
      </div>
    );
  }

  if (action === 'UPDATE') {
    // Case 1: Simple string-to-string change (like Category update)
    if (typeof details.before === 'string' && typeof details.after === 'string') {
      return (
        <div className="small">
          {details.description && <div className="text-dark font-weight-bold mb-1">{details.description}</div>}
          <span className="text-muted">Changed from </span>
          <Badge variant="light" className="border">"{details.before}"</Badge>
          <span className="text-muted mx-1">→</span>
          <Badge variant="info">"{details.after}"</Badge>
        </div>
      );
    }

    // Case 2: Object-based change (loop through keys)
    if (details.after && typeof details.after === 'object') {
      const changes = [];
      const beforeObj = details.before || {};
      
      for (let key in details.after) {
        const beforeVal = beforeObj[key];
        const afterVal = details.after[key];
        
        if (JSON.stringify(beforeVal) !== JSON.stringify(afterVal)) {
          changes.push(`${key}: "${beforeVal || 'none'}" → "${afterVal}"`);
        }
      }

      if (changes.length > 0) {
        return (
          <div>
            {details.description && <div className="small text-dark font-weight-bold mb-1">{details.description}</div>}
            <ul className="list-unstyled mb-0 small">
              {changes.map((c, i) => <li key={i} className="text-muted"><i className="fas fa-caret-right mr-1"></i>{c}</li>)}
            </ul>
          </div>
        );
      }
    }
  }

  return <pre className="mb-0 small" style={{ fontSize: '0.7rem' }}>{JSON.stringify(details, null, 2)}</pre>;
};

export default AuditLogDetails;
